import React from 'react'
import { type InlineInputProps } from '@ztechapps/webui.input'
import { ProductTypeSelectInlineInput } from '../ProductType/ProductTypeSelectInlineInput'
import isEmpty from 'lodash/isEmpty'

export const ProductTypeInlineInput = (props: InlineInputProps) => {
  return (
    <ProductTypeSelectInlineInput
      displayContent={(e) => e?.value}
      label="Type"
      help="The stocking type of the product (e.g. inventory item, non-inventory or services)"
      name="productType"
      validate={(e) => {
        if (isEmpty(e)) throw new Error('Required to have a value.')
      }}
      {...props}
    />
  )
}
